import { z } from 'zod';

export const sessionChargeUpdatedNotificationSchema = z.object({
    type: z.literal('session-charge/updated'),
    payload: z.object({
        clientId: z.uuid(),
    }),
});
